import { render, staticRenderFns } from "./ChatOrderListPanel.vue?vue&type=template&id=c1e6ab18&scoped=true&"
import script from "./ChatOrderListPanel.vue?vue&type=script&lang=js&"
export * from "./ChatOrderListPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderListPanel.vue?vue&type=style&index=0&id=c1e6ab18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e6ab18",
  null
  
)

export default component.exports